export default __webpack_public_path__ + "static/media/newrelic.4b62bde5.svg";